import React, { useState } from "react";
import { SideBar } from "../component/SideBar";
import MobileNavbar from "../component/MobileNavbar";

const ContactPage = () => {
  const [showWarning, setShowWarning] = useState(false);

  const handleRightClick = (e) => {
    e.preventDefault();
    setShowWarning(true);
  };

  return (
    <>
      <MobileNavbar />
      <div className="min-h-screen bg-white font-sans text-gray-700 flex justify-center lg:pt-24 sm:pt-5 md:pt-10 pt-5 gap-40">
        <SideBar />
        {showWarning && (
          <div className="bg-gray-700" style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            padding: '6px 15px',
            zIndex: 1000,
            fontSize: '10px'
          }}>
            <div className="flex justify-between mb-3">
              <h3 className="font-bold text-md">WARNING</h3>
              <button
                onClick={() => setShowWarning(false)}
                style={{
                  marginLeft: '10px',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bolder',
                }}
              >
                X
              </button>
            </div>
            <span>
              All content is protected by copyright and may not be <br /> downloaded or copied.
            </span>
          </div>
        )}
        <div className="w-full max-w-3xl lg:block md:flex md:flex-col md:items-center lg:pl-16">
          <div
            className="relative lg:w-[700px] lg:h-[466px] md:w-[700px] md:h-[466px] h-[37vh] bg-center mb-4 lg:mx-0 md:mx-0 mx-2 rounded-md overflow-hidden bg-no-repeat bg-contain lg:px-14 md:px-14 px-10 flex flex-col lg:pt-24 md:pt-24 pt-16"
            style={{
              backgroundImage: "url('/images/contactPage/contactBg.jpg')",
            }}
            onContextMenu={handleRightClick}>
            <h2 style={{ fontFamily: "Comic Neue, serif", fontStyle: 'italic', fontWeight: '600' }} className="lg:text-2xl md:text-md text-sm mb-6 lg:w-[340px] md:w-[250px] lg:block md:hidden hidden w-[180px] text-red-600">
              Thank you for your precious time ~ it is truly appreciated! <br/>If you would like to get in touch, I
              can always be reached at <br/> <a href="mailto:websitepchakraborty@gmail.com" className="hover:underline hover:text-blue-600 cursor-pointer">websitepchakraborty@gmail.com</a>
            </h2>
            
          </div>
          <div className="lg:flex md:hidden hidden items-center gap-4 mt-4 ml-[500px]">
            <a href=" https://www.youtube.com/@ParamitasCottonCandies" className="text-red-500">
              <img className="w-10" src="/icon/youtube.webp" />
            </a>
            <a href="https://www.instagram.com/paramitasburntbutterflies/" className="text-pink-500">
              <img className="w-6" src="/icon/instagram.png" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100012591636778" className="text-blue-700">
              <img className="w-12" src="/icon/facebook.png" />
            </a>
            <a href="https://www.linkedin.com/in/paramita-chakraborty-72b634192/" className="text-blue-500">
              <img className="w-7" src="/icon/linkedin.webp" />
            </a>
          </div>
          <h2 style={{ fontFamily: "Comic Neue, serif", fontStyle: 'italic', fontWeight: '400' }} className="md:text-lg text-sm mb-10 lg:hidden md:block block text-center text-red-600">
            Thank you for your precious time ~ it is truly appreciated!<br/>If you would like to get in touch, I
            can always be reached at <br/><a href="mailto:websitepchakraborty@gmail.com" className="hover:underline hover:text-blue-600 cursor-pointer">websitepchakraborty@gmail.com</a>
          </h2>
          <div className="flex lg:hidden md:flex items-center justify-center gap-4 fixed bottom-0 w-full bg-white z-50">
            <a href=" https://www.youtube.com/@ParamitasCottonCandies" className="text-red-500">
              <img className="w-10" src="/icon/youtube.webp" />
            </a>
            <a href="https://www.instagram.com/paramitasburntbutterflies/" className="text-pink-500">
              <img className="w-6" src="/icon/instagram.png" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100012591636778" className="text-blue-700">
              <img className="w-12" src="/icon/facebook.png" />
            </a>
            <a href="https://www.linkedin.com/in/paramita-chakraborty-72b634192/" className="text-blue-500">
              <img className="w-7" src="/icon/linkedin.webp" />
            </a>
          </div>

        </div>
      </div>
    </>
  );
};

export default ContactPage;
